import { Component, inject } from '@angular/core';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../../../bary-icon/bary-icon.component';
import { BaryButtonComponent } from '../../../bary-button/bary-button.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'jhi-bary-modal-update-transport-confirm',
  templateUrl: './bary-modal-update-transport-confirm.component.html',
  standalone: true,
  imports: [BaryIconComponent, BaryButtonComponent, NgIf],
})
export class BaryModalUpdateTransportConfirmComponent {
  readonly modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  public message?: string;
  public icon?: string;

  public buttons = {
    submit: '',
    second: '',
  };
  public class = '';

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }
}
